import { VehicleRegistrationInput } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getFormats, useConfig } from '../../../state/configuration'
import { FormInputProps } from '../types'

export const VehicleRegistrationFormInput: FunctionComponent<FormInputProps<string>> = ({
  name,
  value,
  onChange,
  tKey,
  tName,
  t,
}) => {
  const { vehicleRegistration } = useConfig(getFormats)

  return (
    <VehicleRegistrationInput
      name={name}
      onChange={onChange}
      placeholder={t<string>(tKey(tName, 'placeholder'))}
      value={value}
      vrnFormatConfig={vehicleRegistration}
    />
  )
}
